/**
 * 根据ID从数组中查找对应的名称并返回字符串
 * @param {Object} options - 配置选项
 * @param {Array} options.ArrayData - 包含对象的数组，每个对象包含id和name等属性
 * @param {number|string} options.ID - 要查找的ID
 * @param {string} [options.id_key='id'] - 数组中对象的ID键名
 * @param {string} [options.name_key='name'] - 数组中对象的名称键名
 * @param {string} [options.defultStr='-'] - 如果没有找到对应名称时返回的默认字符串
 * @returns {string} - 对应的名称字符串，如果没有找到则返回'-'
 */
export function arrayByIdToNameStr({
    ArrayData,
    ID,
    id_key = 'id',
    name_key = 'name',
    defultStr = '-'
}) {
    if ((!ID && ID !== 0) || !ArrayData) {
        return '-'
    }
    const item = ArrayData.find((_item, index) => {
        return ArrayData[index][id_key] == ID
    })
    return item?.[name_key] || defultStr || '-'
}